import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import humanBlue from './img/human-blue.svg';
import humanOrange from './img/human-orange.svg';
import humanGreen from './img/human-green.svg';
import humanGrey from './img/human-grey.svg';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require('highcharts/modules/pattern-fill')(Highcharts);
import { getChartData, getDatasourceAndDates } from '../../../api'
import { xlsxCustomExport } from '../utils/chartConfig';

const IMG_URL = process.env.IMG_FULL_URL;

const euColor = '#003399';

const humanFigures = [humanOrange, humanGreen, humanGrey];

class ChartHuman extends Component {
	constructor(props) {
		super(props);

		this.state = {
			chartConfig: {
				styledMode: true,
    			title: {
					//useHTML: true,
					text: "<h2 class='title--card'>"+props.title+"</h2>",
					align: 'left',
					widthAdjust:  window.innerWidth > 768 ? -5 : -15,
					y:20,
					style: {
						zIndex: 1,
						lineHeight:33
					},
					margin: 30
				},
				data: {
					enablePolling: true,
					dataRefreshRate: 1
				},
				colors: this.props.colors,
				credits: {
					enabled: true,
					text: "",
					href: '',
					style: {
						cursor: 'arrow'
					},
					position: {
						x: -130
					}
				},
				chart: {
					type: this.props.type,
					backgroundColor: '#F0F0F0',
					events: {
						render: function() {
							let chart = this;
							this.series.forEach(function(series) {
								series.data[0].dataLabel.attr({
								  	y: chart.fullscreen.isOpen ? (chart.chartHeight-170) : chart.clipBox.height
								});					  
							})

						   	if (!chart.customImage)
						   	{
							   	chart.customImage = chart.renderer.image(
									`${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
									chart.chartWidth - 130,
									chart.chartHeight - 37,
									130,
									37
							   	).add();
								chart.customImage.attr({
									class:'osha-logo'
								});
						   	}
						   else
							{
								chart.customImage.attr({
									x: chart.chartWidth - 130,
									y: chart.chartHeight - 37
								});
							}

							if (chart.fullscreen.isOpen) {
								chart.customImage.css({
									display: 'block'
								});
								chart.container.className = 'highcharts-container full-screen';
							}
							else
							{
								chart.customImage.css({
									display: ''
								});	
								chart.container.className = 'highcharts-container';
							}
						}					
				   	},
				},
				exporting: {
					enabled: this.props.fullCountryReport,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadCSV", "downloadXLS"]							
						}
					},
					menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Country', this.series, this.title.textStr, true);
                            }
                        }
                    }
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						},
						verticalAlign: 'top',
						y: 0
					}
				},
				legend:{
					symbolRadius: 0,
					// itemDistance: this.props.fullCountryReport ? 10 : 3,
					itemStyle: {
						fontFamily: 'OpenSans',
						fontWeight: 'normal',
						fontSize:this.props.fullCountryReport ? '12px' : '11px',
						textOverflow: "ellipsis",
					},
					margin: 15,					
					itemMarginTop:8,
					itemMarginBottom:4
				},
				plotOptions: {
					series: {
						dataLabels: {
							enabled: true,
							align: 'center',
							color: '#58585A',
							style: {
								textOutline: 0,
								textShadow: false,
								fontFamily: 'OpenSans-Bold',
								fontSize:'14px'
							},
						},
						events: {
							legendItemClick: function(e) {
								e.preventDefault();
							}
						},
					}
				},
				tooltip: {					
					useHTML: true,
					opacity: 1,
					backgroundColor: "rgba(255, 255, 255, 1)",
					zIndex: 100,
					borderWidth:1,
					borderColor:"#529FA2",
					// followPointer: true,
					// followTouchMove: true,
					style: {
						zIndex: 100
					},
					formatter: function () {						
						return '<ul class="tooltip-item">'+
						'<li><strong>Country: </strong> ' + this.series.name + '</li>' +
						'<li><strong class="tooltip-value up"> Value: </strong>' + this.y +'%</li>' +
						'</ul>';
					}
				},
				xAxis: {
					opposite: true,
					lineWidth: 0,					
					labels: {
						formatter: function () {
							if ([this.value] == 'EU27' || [this.value] == 'EU28' || this.pos == (this.chart.series.length - 1)) {
								return "<span style='color:" + euColor + "'>" + [this.value] + "</span>"
							}
							else {
								return "<span style='color:" + props.colors[this.pos] + "'>" + [this.value] + "</span>"								
							}
						},
						style: {
							textOutline: 0,
							textShadow: false,
							fontFamily: 'OpenSans-Bold',
							fontSize:'14px'							
						},
						autoRotation: false
					},
					type: 'category'
				},
				yAxis: {
					gridLineColor:'#FFF',
					gridLineWidth:2,
					lineWidth: 0,
					max: 250,
					//tickInterval: this.props.tick,
					visible:false,
					title: {
						enabled: false
					}
				},
				series: []
			}
		}
	}

	getLoadData = (chart, indicator, country1, country2, country3, dataset) => {
		let series = [];

		let requestFilter = {
			chart,
			indicator,
			country1,
			country2,
			country3,
			dataset
		}

		getChartData(requestFilter)
			.then((res) => {

				let max = 250; 
				let i = 0;
				let numberOfItems = res.resultset.length;
				let pointWidth = 40;
				if (numberOfItems == 3)
				{
					pointWidth = 60;
				}
				else if (numberOfItems == 4)
				{
					pointWidth = 40;
				}
				else if (this.props.fullCountryReport)
				{
					pointWidth = 70;
				}
				res.resultset.forEach(element => {
					if (element.split == null)
					{
						if (element.value > 200)
						{
							max = 350;
						}
						// There is no split, series and the categories will be the same
						if ( element.countryCode == "EU27_2020" || element.countryCode == "EU28" ){
							series.push({
								name: element.country,
								color:euColor,
								pointWidth: pointWidth,
								borderColor: 'transparent',
								borderWidth: 0,
								data: [{
									name:element.country, 
									y: element.value, 
									x: i, 
									color: {
										pattern: {
											image:humanBlue,
										}
									}									
								}]
							});
						} else {
							series.push({
								name: element.countryCode,
								color:this.props.colors[i],
								pointWidth: pointWidth,
								borderColor: 'transparent',
								data: [{name:element.countryCode, y: element.value, x: i, 
									color: {
										pattern: {
											image: humanFigures[i]
										}
									}}]
							});
						}
						i++;
					}					
				});

				this.setState({
					chartConfig: {...this.state.chartConfig,  series, yAxis: {...this.state.chartConfig.yAxis, max}}
				})
			});		
	}

	getCredits = (chart, dataset) => {
		getDatasourceAndDates(chart, dataset).then((res)=>{
			let text = res;
			this.setState({
				chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
			})
		})		
	}

	componentDidMount() {
		this.getLoadData(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.dataset);
		this.getCredits(this.props.chart, this.props.dataset);
	}

	componentDidUpdate(prevProps, prevState) {

		if (prevProps.selectCountry1 != this.props.selectCountry1) {
			this.getLoadData(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.dataset)
		}

		if (prevProps.selectCountry2 != this.props.selectCountry2) {
			// Check if it's the first time that the country2 is set 
			if (prevProps.selectCountry2 == undefined || prevProps.selectCountry2=='0')
			{
				let series = [];
				this.setState({
					chartConfig: {...this.state.chartConfig, series}
				});
			}
			this.getLoadData(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.dataset)
		}

		if (prevProps.selectCountry3 != this.props.selectCountry3) {
			// Check if it's the first time that the country3 is set 
			if (prevProps.selectCountry3 == undefined || prevProps.selectCountry3=='0')
			{
				let series = [];
				this.setState({
					chartConfig: {...this.state.chartConfig, series}
				});
			}
			this.getLoadData(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.dataset)
		}

		if (prevProps.chart != this.props.chart){
			this.getLoadData(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.dataset);
			this.getCredits(this.props.chart, this.props.dataset);
		}

		if(prevProps.dataset != this.props.dataset){
			this.getLoadData(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.dataset);
			this.getCredits(this.props.chart, this.props.dataset);
		}

		if (prevState.chartConfig.series != this.state.chartConfig.series)
		{
			this.forceUpdate();
		}
	}

	render() {
		// There is a known bug with the Full Screen option, when exiting the chart takes the full height and width of the screen
		// In order to fix it, add a className to the Highcharts element in the containerProps and set a fixed height (in pixels) in the CSS
		// Do not set the height of the chart in the options. If so, when going full screen, it will only take the height configured in the options
		return (
			<div className='chart-container'>
				<HighchartsReact
					highcharts={Highcharts}
					options={this.state.chartConfig}
					containerProps={{ className: 'chartContainer' }}
				/>
			</div>
		)
	}
}

ChartHuman.defaultProps = {
	fullCountryReport: true,
	title: ''
}
export default ChartHuman;
